import React, { useState } from 'react';
import PropTypes from 'prop-types';
import BasicSliderPattern from './components/basic-slider-pattern';
import { iconsList } from '../icon/glyphs';
import Box from '../box';
import Stack from '../stack';

const SliderPattern = ({
  value,
  iconGlyph,
  title = '',
  mixedLabel = '',
  startPoint = 0,
  max,
  min,
  step,
  defaultCollapsed = true,
  indeterminate = false,
  isValueEditable = true,
  onChange = Function.prototype,
  onClick = Function.prototype,
  items = null,
  popoverProps = null,
  valuePopoverProps = null,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);

  const handleClick = () => {
    onClick(!isCollapsed);
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className="ws-ui-slider-pattern">
      <BasicSliderPattern
        title={title}
        mixedLabel={mixedLabel}
        iconGlyph={iconGlyph}
        value={value}
        startPoint={startPoint}
        min={min}
        max={max}
        step={step}
        indeterminate={indeterminate}
        isValueEditable={isValueEditable}
        popoverProps={popoverProps}
        valuePopoverProps={valuePopoverProps}
        selected={!isCollapsed}
        {...(items && { onClick: handleClick })}
        onChange={onChange}
      />

      {items && !isCollapsed && (
        <Box marginTop="spacing-2-xs">
          <Stack gap="spacing-3-xs">
            {items.map((item, index) => (
              <BasicSliderPattern
                // eslint-disable-next-line yola/react/no-array-index-key
                key={index}
                title={title}
                mixedLabel={mixedLabel}
                iconGlyph={item.iconGlyph}
                value={item.value}
                startPoint={startPoint}
                min={min}
                max={max}
                step={step}
                isValueEditable={isValueEditable}
                popoverProps={item.popoverProps}
                valuePopoverProps={item.valuePopoverProps}
                onChange={item.onChange}
              />
            ))}
          </Stack>
        </Box>
      )}
    </div>
  );
};

SliderPattern.propTypes = {
  title: PropTypes.string,
  mixedLabel: PropTypes.string,
  iconGlyph: PropTypes.oneOf(iconsList).isRequired,
  value: PropTypes.number.isRequired,
  startPoint: PropTypes.number,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  step: PropTypes.number.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      iconGlyph: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
      onChange: PropTypes.func.isRequired,
      popoverProps: PropTypes.shape({
        title: PropTypes.node,
        content: PropTypes.node,
        imgSrc: PropTypes.string,
      }),
      popoverValueProps: PropTypes.shape({
        title: PropTypes.node,
        content: PropTypes.node,
        imgSrc: PropTypes.string,
        checkVisibility: PropTypes.func,
      }),
    })
  ),
  popoverProps: PropTypes.shape({
    title: PropTypes.node,
    content: PropTypes.node,
    imgSrc: PropTypes.string,
  }),
  valuePopoverProps: PropTypes.shape({
    title: PropTypes.node,
    content: PropTypes.node,
    imgSrc: PropTypes.string,
    checkVisibility: PropTypes.func,
  }),
  defaultCollapsed: PropTypes.bool,
  indeterminate: PropTypes.bool,
  isValueEditable: PropTypes.bool,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
};

export default SliderPattern;
